export default {
  orderName: "",
  orderDescription: "",
  orderState: "",
  editDisabled: false,
  isPublicOrder: false,
  symbol1: "",
  symbol1FinVolume: 0,
  symbol1QtdVolume: 0,
  symbol2: "",
  symbol2FinVolume: 0,
  symbol2QtdVolume: 0,
  operationType: "",
  method: "",
  startDate: "",
  endDate: "",
  volumeType: "FIN_VOLUME", // 'FIN_VOLUME' ~~ 'QUANTITY'
  entryFactor: 0,
  currentFactor: 0,
  intercept: 0,
  slope: 0,
  residue: 0,
  advancedParams: false,
  TPFactor: 0,
  SLFactor: 0,
  symbol1MinVolume: 0,
  symbol1MaxVolume: 0,
  symbol2MinVolume: 0,
  symbol2MaxVolume: 0,
  tp_sl_calc_type: "factor",
  symbol1Price: 0,
  symbol2Price: 0,
  symbol1Step: 0,
  symbol2Step: 0,
};
